export function classNames(...classNames: string[]): string {
  return classNames.join(' ');
}
